import React, { useEffect, useState } from 'react';

import { FormattedMessage } from 'react-intl';
import { useNavigate, useParams } from 'react-router-dom';

import Header from '@components/Base/Header';
import ProviewAssessmentList from '@components/Candidates';
import messages from '@containers/candidates/messages';
import { getWorkflowCandidateListAction } from '@containers/workflows/slice';
import { useAppDispatch, useAppSelector } from '@utils/hooks';
import { RootState } from '@utils/store';

import { getExamsAction } from './slice';

export type AppliedFilters = {
  selectedDateRange?: { startDate: Date | null; endDate: Date | null } | null;
  selectedAttendee?: { label: string; value: string }[];
  selectedSessionRating?: string[];
  selectedAccomodations?: { label: string; value: string }[];
  selectedStatus?: { label: string; value: string }[];
};

const Candidates = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { step_id, workflow_id } = useParams();
  const { data: examsList, isLoading } = useAppSelector((state: RootState) => state.proviewExamsList);
  const { data: workflowCandidateList } = useAppSelector(
    (state: RootState) => state.workFlowList.workflowCandidateList,
  );
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [appliedFilters, updateAppliedFilters] = useState<AppliedFilters>({});

  const handleNavigateToExam = () => {
    navigate(`/exams`);
  };

  const handleNavigateToWorkflows = () => {
    navigate(`/exams/${workflowCandidateList[0].workflow.course.id}/workflows`, { replace: true });
  };

  useEffect(() => {
    if (!examsList.length) {
      dispatch(getExamsAction());
    }
    if (workflow_id && step_id) {
      const payload = {
        workflow_id: +workflow_id,
        step_id: +step_id,
      };
      dispatch(getWorkflowCandidateListAction(payload));
    }
  }, []);

  return (
    <>
      <Header details={{ label: <FormattedMessage {...messages.candidate} /> }} />
      <div className="flex w-full px-8 pt-3 ml-2 text-gray-500 text-sm font-medium">
        <button className="cursor-pointer" data-testid="exam-btn" onClick={handleNavigateToExam}>
          {workflowCandidateList.length && workflowCandidateList[0]?.workflow?.course?.name
            ? workflowCandidateList[0].workflow.course.name
            : 'Exam'}
        </button>{' '}
        <span className="px-2">{'>'}</span>{' '}
        <button className="cursor-pointer" data-testid="workflow-btn" onClick={handleNavigateToWorkflows}>
          {workflowCandidateList.length && workflowCandidateList[0]?.workflow?.title
            ? workflowCandidateList[0].workflow.title
            : 'Workflows'}
        </button>{' '}
        <span className="px-2">{'>'}</span> <span>Candidates</span>
      </div>
      <ProviewAssessmentList
        appliedFilters={appliedFilters}
        updateAppliedFilters={updateAppliedFilters}
        assessments={examsList}
        isLoading={isLoading}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
      />
    </>
  );
};

export default Candidates;
